import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "catalog-tiles-arrow-right",
  "use": "catalog-tiles-arrow-right-usage",
  "viewBox": "0 0 11 22",
  "content": "<symbol viewBox=\"0 0 11 22\" xmlns=\"http://www.w3.org/2000/svg\" id=\"catalog-tiles-arrow-right\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3.222.13l7.609 10.693-7.596 11.028-2.47-1.702 6.404-9.298L.778 1.87 3.222.13z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id